<template>
  <div class="header">
    <div class="header_content">
      <div class="header_left">
        <span class="scale icon-menu" @click="openSliderBar" v-if="!sliderStatus"></span>
        <tagviews class="visitedtags"></tagviews>
      </div>
      <div class="header_right">
        <div v-if="!sliderStatus || screenWidth > 850">
          <!--      <img src="../assets/img/us.png" alt="" class="country">-->
          <div ref="lang">
            <span @click="languageStatus = !languageStatus" class="choose icon-lang"></span>
            <el-collapse-transition>
              <ul class="language_selection" v-show="languageStatus" v-cloak>
                <li @click="switchLang('zh')" :class="{ active: lang === 'zh' }">中文</li>
                <li @click="switchLang('en')" :class="{ active: lang === 'en' }">English</li>
              </ul>
            </el-collapse-transition>
          </div>
          <img src="../assets/img/icon-user.png" alt="" class="user_pic" />
          <div @click="show = !show" ref="userInfo">
            <span class="user_name">{{ user.firstName || 'users' }}</span>
            <i class="el-icon-arrow-down"></i>
            <el-collapse-transition>
              <ul class="selection" v-show="show" v-cloak>
                <li>{{ $t('message.myProfile') }}</li>
                <li @click="jump()">{{ $t('user.changePassword') }}</li>
                <li @click="logout()">{{ $t('user.Logout') }}</li>
              </ul>
            </el-collapse-transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import tagviews from './tagviews'
import { mapState } from 'vuex'
import { Message } from 'element-ui'
import VueRouter from 'vue-router'

const { isNavigationFailure, NavigationFailureType } = VueRouter

export default {
  name: 'Header',
  components: { tagviews },
  data() {
    return {
      user: {},
      show: false,
      languageStatus: false,
      screenWidth: document.documentElement.clientWidth || document.body.clientWidth
    }
  },
  computed: {
    ...mapState(['sliderStatus', 'lang']),
    sliderStatus() {
      return this.$store.state.sliderStatus
    },
    lang() {
      return this.$store.state.lang
    }
  },
  methods: {
    getUserData: function() {
      let self = this
      axios
        .get('/api/user')
        .then(response => {
          self.$set(this, 'user', response.data)
        })
        .catch(errors => {
          console.log(errors)
          router.push('/').catch(err => {
            // to hide the below error message
            if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
              throw Error(err)
            }
          })
        })
    },
    logout() {
      axios.get('/api/logout').then(res => {
        localStorage.removeItem('email')
        localStorage.removeItem('password')
        router.push('/login').catch(err => {
          // to hide the below error message
          if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
            throw Error(err)
          }
        })
      })
    },
    jump() {
      router.push('/changePass').catch(err => {
        // to hide the below error message
        if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
          throw Error(err)
        }
      })
    },
    openSliderBar(event) {
      event.stopPropagation()
      this.$store.commit('getSliderStatus', true)
    },
    handleResize(event) {
      this.screenWidth = document.documentElement.clientWidth
    },
    switchLang(lang) {
      if (lang === this.$store.state.lang) return
      this.$store.commit('switchLang', lang)
      this.languageStatus = false
      Message({ type: 'success', message: this.$t('message.switchSuccessfully'), showClose: true })
      location.reload()
    }
  },
  mounted() {
    this.getUserData()
    let _this = this
    document.addEventListener('click', e => {
      let swit1 =
        !!_this.$refs.userInfo && !!_this.$refs.userInfo.contains(e.target) && !_this.languageStatus
      let swit2 = !!_this.$refs.lang && !!_this.$refs.lang.contains(e.target) && !_this.show
      if (swit1 || swit2) return
      _this.show = false
      _this.languageStatus = false
    })
  },
  created() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss" scoped>
[v-cloak] {
  display: none;
}
.header {
  width: calc(100% - 267px);
  height: 70px;
  background: $white;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  z-index: 999;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
}

.header_content {
  width: 100%;
  position: relative;
  height: 100%;
  box-sizing: border-box;
}

.header_left {
  max-width: 80%;
  height: 100%;
  @include flex-align-center;
  @include absolute-left-top(43px, 0);
  font-size: 14px;
  font-family: KelsonSans-Bold;
  font-weight: bold;
  color: rgba(31, 37, 62, 0.3);
  .scale {
    display: none;
  }
}

.header_right {
  & > div {
    height: 100%;
    @include flex-align-center;
    @include absolute-right-top(43px, 0);
    cursor: pointer;
  }
  .choose {
    display: inline-block;
    height: 70px;
    line-height: 70px;
    width: 50px;
    text-align: center;
  }
  .country {
    width: 20px;
    height: 20px;
    margin-right: 44px;
  }
  .user_pic {
    width: 30px;
    height: 30px;
    @include border-radius(50%);
  }

  .user_name {
    font-size: 12px;
    color: #222;
    margin: 0 13px;
  }

  .el-icon-arrow-down {
    color: $primary-color;
    cursor: pointer;
  }
  .selection {
    width: 130px;
    height: 145px;
    background: $white;
    padding: 0 24px;
    @include absolute-right-top(-15px, 70px);
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
    z-index: 9999;
    & > li {
      height: 45px;
      line-height: 45px;
      border-bottom: 1px solid #eee;
      text-indent: 8px;
      font-size: 13px;
      color: #333;
      cursor: pointer;
      &:hover {
        color: #f56a40;
      }
      &:last-child {
        border-bottom: 0;
      }
    }
  }
  .language_selection {
    width: 60px;
    height: 100px;
    background: $white;
    padding: 0 10px;
    @include absolute-right-top(90px, 70px);
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
    z-index: 9999;
    & > li {
      height: 45px;
      line-height: 45px;
      border-bottom: 1px solid #eee;
      text-indent: 8px;
      font-size: 13px;
      color: #333;
      cursor: pointer;
      &:hover {
        color: #f56a40;
      }
      &:last-child {
        border-bottom: 0;
      }
    }
    .active {
      color: $primary-color;
      cursor: default;
    }
  }
}

@media screen and (max-width: 850px) {
  .header {
    width: 100%;
  }
  .header_left {
    .scale {
      display: block;
      margin-right: 20px;
      cursor: pointer;
      color: #666;
      height: 70px;
      line-height: 70px;
      width: 20px;
      text-align: center;
    }
    .visitedtags {
      display: none;
    }
  }
}

@media screen and (max-width: 450px) {
  .header {
    height: 50px;
  }
  .header_left {
    @include absolute-left-top(24px, 0);
    .scale {
      height: 50px;
      line-height: 50px;
    }
  }
  .header_right {
    & > div {
      @include absolute-right-top(24px, 0);
    }
    .choose {
      height: 50px;
      line-height: 50px;
    }
    .user_pic {
      width: 20px;
      height: 20px;
    }
    .user_name {
      margin: 0 10px 0 8px;
    }
    .selection {
      @include absolute-right-top(-25px, 51px);
      width: 120px;
      padding: 0 16px;
    }
    .language_selection {
      @include absolute-right-top(85px, 51px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue